export const API_URL = "https://server.ezstock.in/api";
